import React from "react";
import { Box } from "@mui/system";
import Sidebar from "./sidebar";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Avatar,
  IconButton,
} from "@mui/material";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { DataGrid } from "@mui/x-data-grid";
import CustomToolbar from "./CustomToolbarPrint";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import PeopleIcon from "@mui/icons-material/People";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
//import FormControl from '@mui/material/FormControl';
import FormLabel from "@mui/material/FormLabel";

import EditIcon from "@mui/icons-material/Edit";
import OutboxIcon from "@mui/icons-material/Outbox";

import { useNavigate, useLocation } from "react-router-dom";

import { addDoc, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase.js";

import "../App.css";

const steps = [
  "General Information",
  "Housing Journey",
  "Other Agencies",
  "Moses Journey",
  "Addictions & Medication",
  "Rehab Journey",
  "Offending History",
  "Correspondence",
  "Files",
];

let trainingType = [
  "Experiencing Homelessness",
  "Hostel/Shared Accommodation",
  "Sofa Surfing",
  "Living with Friends",
  "Living with Family",
  "Private Rent",
  "Council House",
  "Own House",
];

let rehab = ["Rehab 1", "Rehab 2", "Rehab 3"];
trainingType = trainingType.sort((a, b) => a.localeCompare(b));

export default function Profile() {
  const [inputList, setInputList] = React.useState([
    { firstName: "", lastName: "" },
    1,
    2,
    2,
  ]);
  const [inputList1, setInputList1] = React.useState([
    { firstName: "", lastName: "" },
    1,
  ]);
  const [value, setValue] = React.useState("1");
  const [open, setOpen] = React.useState(false);
  const [dataConc, setdataConc] = React.useState({ concComment: "" });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleRowClick = (params) => {
    console.log(params.row);
    setdataConc(params.row);
    handleOpen();
  };

  const a = useLocation().state.activeStep;

  const [activeStep, setActiveStep] = React.useState(a);
  const [completed, setCompleted] = React.useState({});

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
        // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openImagePreview, setOpenImagePreview] = React.useState(false);
  const handleOpenImagePreview = () => setOpenImagePreview(true);
  const handleCloseImagePreview = () => setOpenImagePreview(false);

  const navigate = useNavigate();

  const employee = useLocation().state.employee;
  const isMiriam = employee.gender === "Female";
  const projectColor = isMiriam ? "#3a103e" : "#0CACEC";
  const projectBg = isMiriam ? "#f7f4f7" : "#f2f9fd";
  let LifeStyle = employee.LifeStyle;

  const columns = [
    { field: "concDate", headerName: "Date", width: 150 },

    {
      field: "concType",
      headerName: "Type",
      width: 150,
    },
    { field: "concComment", headerName: "Information", width: 370 },
    { field: "concLog", headerName: "Logged By", width: 150 },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "50px",
        height: "100vh",
      }}
    >
      <Sidebar />

      {/* Modal */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "#ffffff",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Button
            onClick={() => handleClose()}
            style={{ position: "absolute", right: "0" }}
          >
            <CloseIcon />
          </Button>
          <div className="LoginPage">
            <TextField
              type="date"
              label="Date"
              InputLabelProps={{ shrink: true }}
              className="addform"
              style={{ width: "45%" }}
              id="outlined-basic"
              variant="outlined"
              value={dataConc.concDate}
            />
            <FormControl style={{ width: "45%" }}>
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                value={dataConc.concType}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Type"
              >
                <MenuItem value={dataConc.concType}>{dataConc.concType}</MenuItem>

              </Select>
            </FormControl>
            <TextField
              type="text"
              label="Logged By"
              InputLabelProps={{ shrink: true }}
              className="addform"
              style={{ width: "100%" }}
              id="outlined-basic"
              variant="outlined"
              value={dataConc.concLog}
            />
            <TextField
              value={dataConc.concComment}
              className="addform"
              style={{ width: "100%" }}
              // id={ `tt_description_text outlined-multiline-static`}
              label="Add a comment "
              multiline
              rows={5}
            // onBlur={ (f)=>(this.textOnBlur({id:answeringPainSpot.spotId, value:f.target.value, doc_name:answeringPainSpot.doc_name})) }
            />
          </div>
        </Box>
      </Modal>

      <Button
        variant="contained"
        onClick={() => {
          let a = activeStep;
          navigate("/profileUpdate", {
            state: {
              employee: employee,
              activeStep: a,
            },
          });
        }}
        style={{
          position: "absolute",
          right: "15px",
          bottom: "20px",
          borderRadius: "50",
          width: "50px",
          height: "50px",
          backgroundColor: "#F21D2F",
        }}
      >
        <EditIcon />
      </Button>
      <Button
        variant="contained"
        onClick={async () => {
          await addDoc(collection(db, "archived"), employee);
          await deleteDoc(doc(db, "employee", employee.doc));
          alert("Archived Successfully");
          navigate("/home");
        }}
        style={{
          position: "absolute",
          left: "250px",
          bottom: "20px",
          borderRadius: "50",
          width: "50px",
          height: "50px",
          backgroundColor: "#F21D2F",
        }}
      >
        <OutboxIcon />
      </Button>

      <Box sx={{ width: "60%" }}>
        {<h3>Name: {employee.firstName + " " + employee.surName}</h3>}
        <Stepper
          nonLinear
          activeStep={activeStep}
          alternativeLabel
          sx={{
            "& .Mui-active": {
              color: "#F21D2F",
            },
          }}
        >
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton color="inherit" onClick={handleStep(index)}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          {allStepsCompleted() ? (
            <React.Fragment>
              <div className="LoginPage2">
                <Typography sx={{ mt: 2, mb: 1 }}>
                  Employee Added Sucessfully!!
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button onClick={handleReset} style={{ color: "#F21D2F" }}>
                    Add New
                  </Button>
                </Box>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {/* ADDING FORM */}

              {activeStep == 0 ? (
                <div className="LoginPage">
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      width: "100%",
                      mb: 2,
                      p: 2,
                      pl: 2.5,
                      borderRadius: 2,
                      borderLeft: `8px solid ${projectColor}`,
                      bgcolor: projectBg,
                      overflow: "hidden",
                      backgroundImage: `radial-gradient(circle at 100% 140%, ${projectColor}1f 0 90px, transparent 91px), radial-gradient(circle at 100% 140%, ${projectColor}14 0 160px, transparent 161px)`,
                    }}
                  >
                    {employee.profilePic ? (
                      <Box sx={{ position: "relative", display: "inline-block" }}>
                        <Avatar
                          src={employee.profilePic}
                          sx={{ width: 64, height: 64, bgcolor: projectColor, cursor: "pointer" }}
                          onClick={handleOpenImagePreview}
                        >
                          {employee.firstName ? employee.firstName[0] : "?"}
                        </Avatar>
                        <IconButton
                          onClick={handleOpenImagePreview}
                          size="small"
                          sx={{
                            position: "absolute",
                            bottom: -4,
                            right: -4,
                            bgcolor: "white",
                            "&:hover": { bgcolor: "#f0f0f0" },
                            boxShadow: 1,
                          }}
                        >
                          <ZoomInIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    ) : (
                      <Avatar sx={{ width: 64, height: 64, bgcolor: projectColor }}>
                        <PeopleIcon sx={{ fontSize: 34 }} />
                      </Avatar>
                    )}
                    <Typography variant="h4" sx={{ color: projectColor, fontWeight: 700 }}>
                      {isMiriam ? "The Miriam Project" : "The Moses Project"}
                    </Typography>
                  </Box>
                  <Modal
                    open={openImagePreview}
                    onClose={handleCloseImagePreview}
                    aria-labelledby="image-preview-modal"
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxWidth: "90vw",
                        maxHeight: "90vh",
                        bgcolor: "transparent",
                        boxShadow: 24,
                        outline: "none",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        onClick={handleCloseImagePreview}
                        sx={{
                          alignSelf: "flex-end",
                          color: "white",
                          mb: 1,
                          bgcolor: "rgba(0,0,0,0.5)",
                          "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                        }}
                      >
                        <CloseIcon />
                      </Button>
                      <img
                        src={employee.profilePic}
                        alt="Profile"
                        style={{
                          maxWidth: "80vw",
                          maxHeight: "80vh",
                          borderRadius: 8,
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Modal>
                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="First Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.firstName}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Surname"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.surName}
                    active
                  />
                  <FormControl style={{ width: "45%" }}>
                    <InputLabel id="demo-simple-select-label">
                      Status{" "}
                    </InputLabel>
                    <Select
                      value={employee.statusc}
                      style={{
                        backgroundColor: employee.statusc,
                        color: "white",
                      }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Location"
                    >
                      <MenuItem
                        value={"GREEN"}
                        style={{ backgroundColor: "green", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                      <MenuItem
                        value={"ORANGE"}
                        style={{ backgroundColor: "Orange", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                      <MenuItem
                        value={"RED"}
                        style={{ backgroundColor: "red", color: "white" }}
                      >
                        ㅤ
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    type="date"
                    label="Date of Birth"
                    InputLabelProps={{ shrink: true }}
                    className="addform"
                    style={{ width: "45%" }}
                    id="outlined-basic"
                    variant="outlined"
                    value={employee.DOB}
                    active
                  />
                  <TextField
                    className="addform"
                    label="Gender"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.gender || ""}
                    active
                  />
                  {/* <FormControl style={{ display: "flex", flexDirection: "row", gap: "30px" }}>
                      <FormLabel id="demo-radio-buttons-group-label" style={{ alignSelf: "center" }}>Experiencing Homelessness</FormLabel>
                      <RadioGroup
                        value={employee.homeless}
                        row
                        aria-labelledby="demo-radio-buttons-group-label"

                        name="radio-buttons-group"
                      >
                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio />} label="NO" />
                      </RadioGroup>
                    </FormControl> */}
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Contact"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.contact}
                    active
                  />
                  <TextField
                    type="email"
                    className="addform"
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.email}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="National Insurance"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.nationalInsurance}
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 1"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.address1}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Address 2"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.address2}
                    active
                  />

                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Town/County"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.town}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Post Code"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.postCode}
                    active
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Qty of Children"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.child}
                    active
                  />
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Children’s Location"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.childloc}
                    active
                  />

                  <TextField
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Name"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.nextOfKinName}
                    active
                  />
                  <TextField
                    type="number"
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Number"
                    variant="outlined"
                    style={{ width: "45%" }}
                    value={employee.nextOfKinNumber}
                    active
                  />
                  {/* <TextField type="text" className='addform' id="outlined-basic" label="Next of Kin Relationship" variant="outlined" style={{ width: "45%" }} value={employee.nextOfKineRelationship} active /> */}
                  <TextField
                    type="text"
                    className="addform"
                    id="outlined-basic"
                    label="Next of Kin Relationship"
                    variant="outlined"
                    style={{ width: "45%", visibility: "hidden" }}
                  />

                  <div style={{ flexBasis: "100%", height: 0 }} />
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      marginTop: "30px",
                      width: "48%",
                      color: "#F21D2F",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "48%",
                      height: "50px",
                      marginTop: "30px",
                      backgroundColor: "#F21D2F",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              ) : activeStep == 1 ? (
                <>
                  <div className="LoginPageALT">
                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Referral From{" "}
                      </InputLabel>
                      <Select
                        value={employee.referralForm || ""}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Referral From"
                        InputProps={{
                          readOnly: true,
                        }}
                      >
                        <MenuItem value={employee.referralForm || ""}>{employee.referralForm || ""}</MenuItem>
                      </Select>
                    </FormControl>
                    
                    {employee.referralForm === "Others" && employee.referralOthersDetails && (
                      <TextField
                        className="addform"
                        id="outlined-basic"
                        label="Please specify"
                        variant="outlined"
                        style={{ width: "45%" }}
                        value={employee.referralOthersDetails}
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    )}
                  </div>
                  <hr className="solid" />
                  <div className="LoginPageALT">
                    {employee.house.map((x, i) => {
                      return (
                        <div style={{ width: "100%", display: "flex", gap: "10px" }}>
                          <FormControl style={{ width: "30%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>
                            <Select
                              // onChange={e => handleInputChange(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Status"
                              value={x.status}
                            >

                              <MenuItem value={x.status}>{x.status}</MenuItem>

                            </Select>
                          </FormControl>

                          <TextField
                            type="text"
                            label="Location"
                            className="addform"
                            style={{ width: "30%" }}
                            id="outlined-basic"
                            variant="outlined"
                            value={x.location || ""}
                            InputProps={{
                              readOnly: true,
                            }}
                          />

                          <TextField
                            type="date"
                            label="Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "30%" }}
                            id="outlined-basic"
                            variant="outlined"
                            value={x.date}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </div>
                      );
                    })}

                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 2 ? (
                <>
                  <div style={{ marginTop: "10px" }}>
                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.AdultCare.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.AdultCare.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.AdultCare.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.AdultCare.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.MentalHealth.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.MentalHealth.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.MentalHealth.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.MentalHealth.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.CGL.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.CGL.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.CGL.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.CGL.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.Housing.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Housing.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.Housing.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Housing.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.SocialServices.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.SocialServices.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.SocialServices.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.SocialServices.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.Probation.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Probation.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.Probation.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Probation.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.FoodBank.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.FoodBank.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.FoodBank.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.FoodBank.Contactname}
                    />
                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.GP.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.GP.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select value={employee.Agencies.GP.Consent} size="small">
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.GP.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.Blank1.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Blank1.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.Blank1.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Blank1.Contactname}
                    />

                    {/* ------------------- NEW LINE ----------------------------- */}

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={employee.Agencies.Blank2.Name}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Blank2.Name}
                    />

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Consent
                      </InputLabel>
                      <Select
                        value={employee.Agencies.Blank2.Consent}
                        size="small"
                      >
                        <MenuItem value={"YES"}>YES</MenuItem>
                        <MenuItem value={"NO"}>NO</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      size="small"
                      className="addform"
                      id="outlined-basic"
                      label={"Contact Name"}
                      variant="outlined"
                      style={{ width: "32%", margin: "5px" }}
                      value={employee.Agencies.Blank2.Contactname}
                    />
                  </div>

                  <div className="LoginPageALT">
                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 3 ? (
                <div className="ALTBox">
                  <div
                    style={{ display: "flex", marginTop: "50px", gap: "10px" }}
                  >
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      className="addform"
                      id="outlined-basic"
                      label="Registered Date"
                      variant="outlined"
                      style={{ width: "45%", flex: 2 }}
                      value={employee.startDate}
                    />
                    <TextField
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      className="addform"
                      id="outlined-basic"
                      label="Actual End Date"
                      variant="outlined"
                      style={{ width: "45%", flex: 2 }}
                      value={employee.expectedDate}
                    />
                    <FormControl style={{ width: "45%", flex: 2 }}>
                      <InputLabel id="outcome-select-label">Outcome</InputLabel>
                      <Select
                        value={employee.outcome || ""}
                        labelId="outcome-select-label"
                        id="outcome-select"
                        label="Outcome"
                      >
                        <MenuItem value={""}></MenuItem>
                        <MenuItem value={"Rehab Successful"}>
                          Rehab Successful
                        </MenuItem>
                        <MenuItem value={"Deceased"}>Deceased</MenuItem>
                        <MenuItem value={"Barred"}>Barred</MenuItem>
                        <MenuItem value={"Unknown"}>Unknown</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div style={{ marginTop: "20px" }} id="LIFESTYLE">
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Alcohol Misuse/Addiction
                      </InputLabel>
                      <Select
                        value={LifeStyle.Alchohol}
                        // onChange={e => setLifeStyle({ ...LifeStyle, Alchohol: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Offending Behaviour
                      </InputLabel>
                      <Select
                        value={LifeStyle.Behaviour}
                        // onChange={e => setLifeStyle({ ...LifeStyle, Behaviour: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Depression
                      </InputLabel>
                      <Select
                        value={LifeStyle.Depression}
                        //  onChange={e => setLifeStyle({ ...LifeStyle, Depression: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Drug Missuse/Addiction
                      </InputLabel>
                      <Select
                        value={LifeStyle.Drug}
                        //onChange={e => setLifeStyle({ ...LifeStyle, Drug: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Eating Disorder
                      </InputLabel>
                      <Select
                        value={LifeStyle.Eating}
                        //  onChange={e => setLifeStyle({ ...LifeStyle, Eating: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Mental Health
                      </InputLabel>
                      <Select
                        value={LifeStyle.Mental}
                        //  onChange={e => setLifeStyle({ ...LifeStyle, Mental: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Debt Problems
                      </InputLabel>
                      <Select
                        value={LifeStyle.Debt}
                        //   onChange={e => setLifeStyle({ ...LifeStyle, Debt: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Self Harm
                      </InputLabel>
                      <Select
                        value={LifeStyle.Self}
                        //    onChange={e => setLifeStyle({ ...LifeStyle, Self: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Physical Health
                      </InputLabel>
                      <Select
                        value={LifeStyle.Physical}
                        //    onChange={e => setLifeStyle({ ...LifeStyle, Physical: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Unemployment
                      </InputLabel>
                      <Select
                        value={LifeStyle.Unemployment}
                        //    onChange={e => setLifeStyle({ ...LifeStyle, Unemployment: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Low Self Esteem/Confidence
                      </InputLabel>
                      <Select
                        value={LifeStyle.Confidence}
                        //     onChange={e => setLifeStyle({ ...LifeStyle, Confidence: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Violent Behaviour
                      </InputLabel>
                      <Select
                        value={LifeStyle.Violent}
                        //   onChange={e => setLifeStyle({ ...LifeStyle, Violent: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Low Self Esteem/Confidence"
                      >
                        <MenuItem value={"C"}>C</MenuItem>
                        <MenuItem value={"P"}>P</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <div className="LoginPageALT">
                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#F21D2F",
                        borderColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#F21D2F",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </div>
              ) : activeStep == 4 ? (
                <>
                  <div style={{ marginTop: "30px" }}>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Alcohol
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Alchohol}
                        // onChange={e => setRehabDrugs({ ...RehabDrugs, Alchohol: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Amphetamines
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Amphetamines}
                        //  onChange={e => setRehabDrugs({ ...RehabDrugs, Amphetamines: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Cannabis
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Cannabis}
                        // onChange={e => setRehabDrugs({ ...RehabDrugs, Cannabis: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Cocaine
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Cocaine}
                        //  onChange={e => setRehabDrugs({ ...RehabDrugs, Cocaine: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Crack
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Crack}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Ecstasy
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Ecstasy}
                        //onChange={e => setRehabDrugs({ ...RehabDrugs, Ecstasy: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Heroin
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Heroine}
                        // onChange={e => setRehabDrugs({ ...RehabDrugs, Heroine: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Ketamine
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Ketamine}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Pregabline
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Pregabline}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Smoker
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Cigrates}
                        // onChange={e => setRehabDrugs({ ...RehabDrugs, Cigrates: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Spice
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Spice}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Vaping
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Vaping}
                        // onChange={e => setRehabDrugs({ ...RehabDrugs, Cigrates: e.target.value })}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Vaping"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Zopiclone
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Zopiclone}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <FormControl style={{ width: "32%", margin: "5px" }}>
                      <InputLabel id="demo-simple-select-label">
                        Other
                      </InputLabel>
                      <Select
                        value={employee.RehabDrugs.Other}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl
                      style={{
                        width: "32%",
                        margin: "5px",
                        visibility: "hidden",
                      }}
                    >
                      <InputLabel id="demo-simple-select-label">
                        Ecstasy
                      </InputLabel>
                      <Select
                        // value={inputList1[i].location}
                        // name="location"
                        // onChange={e => handleInputChange1(e, i)}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"N"}>N</MenuItem>
                        <MenuItem value={"O"}>O</MenuItem>
                        <MenuItem value={"OCC"}>OCC</MenuItem>
                        <MenuItem value={"R"}>R</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="LoginPage">
                    <TextField
                      className="addform"
                      id="outlined-basic"
                      label="Medical History"
                      variant="outlined"
                      style={{ width: "48%", marginRight: "1%" }}
                      multiline
                      rows={6}
                      value={employee.medicalHistory || ""}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <TextField
                      className="addform"
                      id="outlined-basic"
                      label="Prescribed Medication"
                      variant="outlined"
                      style={{ width: "48%", marginLeft: "1%" }}
                      multiline
                      rows={6}
                      value={employee.prescribedMedication || ""}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#1c3261",
                        borderColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 5 ? (
                <>
                  <div className="LoginPage">
                    {employee.rehab.map((x, i) => {
                      return (
                        <div style={{ width: "100%" }}>
                          <FormControl style={{ width: "18%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Status
                            </InputLabel>
                            <Select
                              // onChange={e => handleInputChange(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                              value={x.status}
                            >
                              <MenuItem value={x.status}>{x.status}</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl
                            style={{ width: "10%", marginLeft: "10px" }}
                          >
                            <InputLabel id="demo-simple-select-label">
                              Location
                            </InputLabel>
                            <Select
                              // onChange={e => handleInputChange(e, i)}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                              value={x.location}
                            >

                              <MenuItem value={x.location}>{x.location}</MenuItem>

                            </Select>
                          </FormControl>

                          <TextField
                            value={x.startDate}
                            name="startDate"
                            type="date"
                            label="Start Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            value={x.endDate}
                            name="endDate"
                            type="date"
                            label="End Date"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />

                          <TextField
                            type="number"
                            label=" Expense £"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "10%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                            value={x.value}
                          />
                          <TextField
                            value={x.comment}
                            name="comment"
                            type="text"
                            label="Expense Comments"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "18%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                        </div>
                      );
                    })}

                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#1c3261",
                        borderColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 6 ? (
                <>
                  <div className="LoginPageALT">
                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Prison Leaver{" "}
                      </InputLabel>
                      <Select
                        value={employee.prison}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Prison Leaver"
                      >
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="How many times"
                      variant="outlined"
                      style={{ width: "45%" }}
                      value={employee.howMany}
                    />

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="Total Months Served"
                      variant="outlined"
                      style={{ width: "45%" }}
                      value={employee.totlaMonthsServed}
                    />

                    <FormControl style={{ width: "45%" }}>
                      <InputLabel id="demo-simple-select-label">
                        Probation{" "}
                      </InputLabel>
                      <Select
                        value={employee.probation}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Location"
                      >
                        <MenuItem value={"yes"}>Yes</MenuItem>
                        <MenuItem value={"no"}>No</MenuItem>
                        <MenuItem value={"null"}></MenuItem>
                      </Select>
                    </FormControl>

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label="Probation Officer"
                      variant="outlined"
                      style={{ width: "45%" }}
                      value={employee.probationOfficer}
                    />

                    <TextField
                      type="number"
                      className="addform"
                      id="outlined-basic"
                      label="Number of Offences"
                      variant="outlined"
                      style={{ width: "45%" }}
                      value={employee.numberOfOffences}
                    />

                    <TextField
                      type="text"
                      className="addform"
                      id="outlined-basic"
                      label="Next of Kin Relationship"
                      variant="outlined"
                      style={{ width: "45%", visibility: "hidden" }}
                    />
                  </div>
                  <hr className="solid" />
                  <div className="LoginPageALT">
                    {employee.convication.map((x, i) => {
                      return (
                        <div style={{ width: "100%" }}>
                          <FormControl style={{ width: "28%" }}>
                            <InputLabel id="demo-simple-select-label">
                              Conviction Type
                            </InputLabel>
                            <Select
                              value={x.type}
                              name="type"
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Location"
                            >
                              <MenuItem value={x.type}>{x.type}</MenuItem>

                            </Select>
                          </FormControl>

                          <TextField
                            value={x.details ? x.details : ""}
                            name="text"
                            type="text"
                            label="Details"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "28%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                          <TextField
                            value={x.date}
                            name="date"
                            type="date"
                            label="Date of Conviction"
                            InputLabelProps={{ shrink: true }}
                            className="addform"
                            style={{ width: "28%", marginLeft: "10px" }}
                            id="outlined-basic"
                            variant="outlined"
                          />
                        </div>
                      );
                    })}

                    <div style={{ flexBasis: "100%", height: 0 }} />
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className="addform"
                      variant="outlined"
                      style={{
                        width: "48%",
                        color: "#1c3261",
                        borderColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                    </Button>
                    <Button
                      onClick={handleComplete}
                      className="addform"
                      variant="contained"
                      style={{
                        width: "48%",
                        backgroundColor: "#1c3261",
                        height: "50px",
                        marginTop: "30px",
                      }}
                    >
                      {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                    </Button>
                  </div>
                </>
              ) : activeStep == 7 ? (
                <div className="LoginPage">
                  <div style={{ height: 340, width: "100%" }}>
                    <DataGrid
                      rows={employee.conc}
                      columns={columns}
                      pageSize={5}
                      rowsPerPageOptions={[5]}
                      style={{ width: "100%" }}
                      onRowDoubleClick={handleRowClick}
                      // getRowClassName={(params) => `${params.row.color}`}
                      components={{
                        Toolbar: CustomToolbar,
                      }}
                    />
                  </div>

                  <div style={{ flexBasis: "100%", height: 0 }} />
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "48%",
                      color: "#1c3261",
                      borderColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  <Button
                    onClick={handleComplete}
                    className="addform"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#1c3261",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Next" : "Next"}
                  </Button>
                </div>
              ) : activeStep == 8 ? (
                <div className="LoginPage">
                  <ul>
                    {(employee.files || [])
                      .filter(
                        (item) => item && typeof item === "object" && item.url
                      )
                      .map((item) => {
                        return (
                          <li key={item.url}>
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noreferrer"
                              download={item.name}
                            >
                              {item.name || item.url}
                            </a>
                          </li>
                        );
                      })}
                  </ul>

                  <div style={{ flexBasis: "100%", height: 0 }} />
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className="addform"
                    variant="outlined"
                    style={{
                      width: "48%",
                      color: "#F21D2F",
                      borderColor: "#F21D2F",
                      height: "50px",
                      marginTop: "30px",
                    }}
                  >
                    {completedSteps() === totalSteps() - 1 ? "Back" : "Back"}
                  </Button>
                  {/* <Button onClick={pushData} className='addform' variant="contained" style={{ width: "48%", backgroundColor: "#F21D2F", height: "50px", marginTop: "30px" }}>{completedSteps() === totalSteps() - 1
                              ? 'Finish'
                              : 'Next'}</Button> */}
                </div>
              ) : <></>}

              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                {/* <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </Button> */}
                <Box sx={{ flex: "1 1 auto" }} />
                {/* <Button onClick={handleNext} sx={{ mr: 1 }}>
                    Next
                  </Button>
                  {activeStep !== steps.length &&
                    (completed[activeStep] ? (
                      <Typography variant="caption" sx={{ display: 'inline-block' }}>
                        Step {activeStep + 1} already completed
                      </Typography>
                    ) : (
                      <Button onClick={handleComplete}>
                        {completedSteps() === totalSteps() - 1
                          ? 'Finish'
                          : 'Complete Step'}
                      </Button>
                    ))} */}
              </Box>
            </React.Fragment>
          )}
        </div>
      </Box>

      {/* <TabContext value={value}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <TabList onChange={handleChange} aria-label="lab API tabs example">
          <Tab label="General Information" value="1" />
          <Tab label="Contact Details" value="2" />
          <Tab label="Emergency Contact" value="3" />
          <Tab label="Driving Details" value="4" />
        </TabList>
      </Box>
      <TabPanel value="1" style={{display: "flex"}}>
                            <div style={{width: "48%", display: "flex", flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Name:</b></p>
                                <p> Iqbal</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Job Title:</b></p>
                                <p>Driver</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Post Code:</b></p>
                                <p>75800</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Email:</b></p>
                                <p>test@xyz.com</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>DOB:</b></p>
                                <p>17/1/2004</p>
                            </div>
                          </div>

                          <div style={{width: "48%", display: "flex",  flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Surname:</b></p>
                                <p>Test</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Address:</b></p>
                                <p>Test</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Contact:</b></p>
                                <p>03123456789</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Location:</b></p>
                                <p>Test</p>
                            </div>
                          </div>

      </TabPanel>
      <TabPanel value="2" style={{display: "flex"}}>
      <div style={{width: "48%", display: "flex", flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>National Insurance Number:</b></p>
                                <p> 1234567890</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Rate of Pay:</b></p>
                                <p>435$</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Contact Signed:</b></p>
                                <p>Yes</p>
                            </div>
                            
                          </div>

                          <div style={{width: "48%", display: "flex",  flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Probation Period:</b></p>
                                <p>3 Months</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Joining:</b></p>
                                <p>12/2/2022</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Period:</b></p>
                                <p>Monthly</p>
                            </div>
                            
                          </div>
                         
      </TabPanel>
      <TabPanel value="3" style={{display: "flex"}}>
      <div style={{width: "48%", display: "flex", flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Next of Kin Name:</b></p>
                                <p> Talha</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Next of Kin Relationship:</b></p>
                                <p>SON</p>
                            </div>
                            
                            
                          </div>

                          <div style={{width: "48%", display: "flex",  flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Next of Kin Number:</b></p>
                                <p>0123456789</p>
                            </div>
                            
                            
                          </div>
                         
      </TabPanel>
      <TabPanel value="4" style={{display: "flex"}}>
      <div style={{width: "48%", display: "flex", flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Licence Number:</b></p>
                                <p> 1234567890</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Van Make Model:</b></p>
                                <p>2022</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Car Allowance:</b></p>
                                <p>Yes</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Insurance:</b></p>
                                <p>Yes</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Public Liability Insurance:</b></p>
                                <p>Yes</p>
                            </div>
                            
                          </div>

                          <div style={{width: "48%", display: "flex",  flexDirection: "column"}}>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Van Reg:</b></p>
                                <p>3 Months</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Fuel Card:</b></p>
                                <p>012</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Millage:</b></p>
                                <p>2000020</p>
                            </div>
                            <div style={{width: "100%", display: "flex", justifyContent: "space-evenly"}}>
                                < p ><b>Employee Liability Insurance:</b></p>
                                <p>Yes</p>
                            </div>
                            
                          </div>
                         
      </TabPanel>
      
    </TabContext> */}
    </Box>
  );
}
